export const omegaFontsCss = `
@font-face {
  font-family: "Omega Sans";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url("/fonts/Omega+Sans+Regular.ttf") format("truetype");
}

@font-face {
  font-family: "Broadway";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url("/fonts/Broadway.ttf") format("truetype");
}

@font-face {
  font-family: "Broadway BT";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url("/fonts/broadway-regular.ttf") format("truetype");
}
`
